import Helper from "../../Helper";
import { Equipment } from "../../models/Equipment";
import { MapObject } from "../../models/MapObject";

export function getEquipmentForProject(
    subdomain: string = "",
    projectToken: string,
    timezone: string,
    archived: boolean = false
): Promise<Equipment[]> {
    let url = "/projects/" + projectToken + "/equipment?archived=" + archived;

    if (subdomain && subdomain.length > 0) {
        url = Helper.baseUrlAltSubdomain(subdomain) + url;
    }

    return fetch(url, {
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            if (res.ok) {
                return res.json();
            }

            throw new Error("Failed to get project equipments");
        })
        .then((res) => {
            return res.map((eq) => Equipment.fromApiObject(eq, timezone));
        })
        .catch(() => {
            return new Array<Equipment>();
        });
}

export function getEquipmentAttachments(
    subdomain: string = "",
    projectToken: string,
    equipmentId: number
): Promise<any[]> {
    let url = "/projects/" + projectToken + "/equipment/" + equipmentId + "/equipment_attachments";

    if (subdomain && subdomain.length > 0) {
        url = Helper.baseUrlAltSubdomain(subdomain) + url;
    }

    return fetch(url, {
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            if (res.ok) {
                return res.json();
            }

            throw new Error("Failed to get equipment attachments");
        })
        .catch(() => {
            return [];
        });
}

export function deleteEquipment(subdomain: string = "", projectToken: string, equipment: Equipment): Promise<boolean> {
    let url = "/projects/" + projectToken + "/equipment/" + equipment.id;

    if (subdomain && subdomain.length > 0) {
        url = Helper.baseUrlAltSubdomain(subdomain) + url;
    }

    return fetch(url, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            if (res.ok) {
                return true;
            }

            throw new Error("Failed to delete equipment");
        })
        .catch(() => {
            return false;
        });
}

export function createEquipment(
    subdomain: string = "",
    projectToken: string,
    newEquipment: Equipment,
    newMapObject: MapObject,
    taggedTeams: number[],
    timezone: string
): Promise<Equipment | null> {
    let url = "/projects/" + projectToken + "/equipment";

    if (subdomain && subdomain.length > 0) {
        url = Helper.baseUrlAltSubdomain(subdomain) + url;
    }

    return fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            equipment: newEquipment.toApiObject(),
            map_object: newMapObject.toApiObject(),
            tagged_teams: taggedTeams,
        }),
    })
        .then((res) => {
            if (res.ok) {
                return res.json();
            }

            throw new Error("Failed to create equipment");
        })
        .then((eq) => Equipment.fromApiObject(eq, timezone))
        .catch(() => {
            return null;
        });
}

export function updateEquipment(
    subdomain: string = "",
    projectToken: string,
    equipment: Equipment,
    taggedTeams: number[],
    timezone: string
): Promise<Equipment | null> {
    let url = "/projects/" + projectToken + "/equipment/" + equipment.id;

    if (subdomain && subdomain.length > 0) {
        url = Helper.baseUrlAltSubdomain(subdomain) + url;
    }

    return fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ equipment: equipment.toApiObject(), tagged_teams: taggedTeams }),
    })
        .then((res) => {
            if (res.ok) {
                return res.json();
            }

            throw new Error("Failed to update equipment");
        })
        .then((eq) => Equipment.fromApiObject(eq, timezone))
        .catch(() => {
            return null;
        });
}
